/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SesModule
 */
export interface SesModule {
    /**
     * 
     * @type {boolean}
     * @memberof SesModule
     */
    enabled?: boolean;
}

/**
 * Check if a given object implements the SesModule interface.
 */
export function instanceOfSesModule(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SesModuleFromJSON(json: any): SesModule {
    return SesModuleFromJSONTyped(json, false);
}

export function SesModuleFromJSONTyped(json: any, ignoreDiscriminator: boolean): SesModule {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': !exists(json, 'enabled') ? undefined : json['enabled'],
    };
}

export function SesModuleToJSON(value?: SesModule | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

